import axios from 'axios'

const axiosInstance = axios.create()

const token = document.querySelector('[name=csrf-token]').content
axiosInstance.defaults.headers.common['X-CSRF-TOKEN'] = token
axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default axiosInstance
